import { StyleSheet, Platform } from 'react-native';
import { SPACING, RADIUS, COLORS, SHADOWS, TYPOGRAPHY } from '../constants/theme';

/**
 * Shared form styles for consistent theming across all forms
 * To change the theme, update the constants in theme.ts
 */
export const FormStyles = StyleSheet.create({
    // Container styles
    container: {
        flex: 1,
        backgroundColor: COLORS.gradients.primary.start,
    },
    scrollContent: {
        flexGrow: 1,
        justifyContent: 'center',
        padding: SPACING.xl,
    },
    formContainer: {
        flex: 1,
        width: '100%',
        backgroundColor: COLORS.gradients.primary.start,
        padding: SPACING.xl,
    },
    
    // Header styles
    formHeader: {
        alignItems: 'center',
        marginBottom: SPACING.xl,
    },
    formTitle: {
        fontSize: TYPOGRAPHY.fontSize['3xl'],
        fontWeight: TYPOGRAPHY.fontWeight.bold,
        color: COLORS.white,
        marginBottom: SPACING.xs,
        includeFontPadding: false,
        textShadowColor: 'rgba(0, 0, 0, 0.2)',
        textShadowOffset: { width: 0, height: 2 },
        textShadowRadius: 4,
    },
    formSubtitle: {
        fontSize: TYPOGRAPHY.fontSize.md,
        color: 'rgba(255, 255, 255, 0.9)',
        includeFontPadding: false,
    },
    
    // Form body
    formBody: {
        width: '100%',
    },
    
    // Form group (field container)
    formGroup: {
        marginBottom: SPACING.lg,
    },
    
    // Label styles
    formLabel: {
        marginBottom: SPACING.xs,
        color: COLORS.white,
        fontWeight: TYPOGRAPHY.fontWeight.semibold,
        fontSize: TYPOGRAPHY.fontSize.md,
        includeFontPadding: false,
    },
    
    // Input styles
    formInput: {
        width: '100%',
        padding: SPACING.md,
        borderWidth: 2,
        borderColor: COLORS.form.inputBorder,
        borderRadius: RADIUS.md,
        fontSize: TYPOGRAPHY.fontSize.md,
        backgroundColor: COLORS.form.inputBackground,
        color: COLORS.form.inputText,
        ...Platform.select({
            ios: {
                paddingTop: 14,
                paddingBottom: 14,
            },
        }),
        zIndex: 10000
    },
    formInputError: {
        borderColor: COLORS.form.inputBorderError,
    },
    
    // Error message styles
    errorMessage: {
        color: COLORS.error,
        fontSize: TYPOGRAPHY.fontSize.sm,
        marginTop: SPACING.xs,
        includeFontPadding: false,
    },
    apiErrorContainer: {
        marginBottom: SPACING.md,
        padding: SPACING.md,
        backgroundColor: COLORS.form.errorBackground,
        borderRadius: RADIUS.md,
    },
    
    // Form actions (button container)
    formActions: {
        flexDirection: 'row',
        gap: SPACING.md,
        marginTop: SPACING.xl,
        flexWrap: 'wrap',
    },
});
